var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrder404(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 431.91 393.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#b5dfea;}.cls-3{fill:#90cedd;}.cls-19,.cls-3{opacity:0.55;}.cls-4{fill:#79c9e8;}.cls-5{fill:#d7f0f9;}.cls-6{fill:#0582c1;}.cls-7{fill:#fff;}.cls-8{fill:#ffbf4d;}.cls-9{fill:#00668e;}.cls-10{fill:#05556d;}.cls-11{fill:#f98d3d;}.cls-12{fill:#ed701b;}.cls-13{fill:none;}.cls-14{fill:#efaa3a;}.cls-15{fill:#f98d2b;mix-blend-mode:multiply;opacity:0.29;}.cls-16{fill:#49b4d6;}.cls-17{fill:#ff9f50;}.cls-18{fill:#f77e2d;}.cls-19{mix-blend-mode:overlay;fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 237.37,
    y1: 361.34,
    x2: 237.37,
    y2: 337.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#fff",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fff",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#fff",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#fff",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M419,393.56A12.73,12.73,0,0,0,431.75,381c.53-34.64,3.32-85.74-61.93-99.88C317,269.72,348.33,175.88,206.14,182c-102.08,4.35-75,90.38-154.32,97.55C-1,284.27-1.45,351.06.58,381.66a12.73,12.73,0,0,0,12.71,11.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M369.82,281.15C317,269.72,348.33,175.88,206.14,182c-24.28,1-41.24,6.69-54.07,14.81,4.32-.57,8.91-1,13.8-1.17,142.19-6.07,110.89,87.76,163.69,99.2,64.55,14,62.5,64.15,61.94,98.77H419A12.73,12.73,0,0,0,431.75,381C432.28,346.39,435.07,295.29,369.82,281.15Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 143.73,
    width: 2.24,
    height: 163.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 304.7,
    width: 2.24,
    height: 188.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M306.73,178l-167-19.49a13,13,0,0,0-14.42,11.41L112.9,276.63a13,13,0,0,0,11.41,14.42l167,19.49a13,13,0,0,0,14.42-11.41l12.46-106.76A13,13,0,0,0,306.73,178Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M316.91,202.94l1.23-10.57A13,13,0,0,0,306.73,178l-167-19.49a13,13,0,0,0-14.42,11.41l-1.24,10.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151.14,245.08l21.16-37.29a6.82,6.82,0,0,1,6.74-3.41h0a6.82,6.82,0,0,1,6,7.58l-4.4,37.72.19,0A4.73,4.73,0,0,1,185,255h0a4.75,4.75,0,0,1-5.26,4.16l-.19,0-.8,6.87a5.11,5.11,0,0,1-5.67,4.49h0a5.11,5.11,0,0,1-4.49-5.67l.8-6.87-15.23-1.78a4.74,4.74,0,0,1-4.17-5.26l.41-3.46A5.94,5.94,0,0,1,151.14,245.08Zm19.4,2.79,2.73-23.39a.15.15,0,0,0-.28-.09l-12.5,22.06a.63.63,0,0,0,.47.93l8.89,1A.63.63,0,0,0,170.54,247.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.53,256l21.16-37.29a6.85,6.85,0,0,1,6.74-3.41h0a6.84,6.84,0,0,1,6,7.58L274,260.58l.19,0a4.73,4.73,0,0,1,4.15,5.25h0a4.73,4.73,0,0,1-5.25,4.16l-.19,0-.8,6.87a5.12,5.12,0,0,1-5.68,4.48h0a5.1,5.1,0,0,1-4.48-5.67l.8-6.87L247.53,267a4.74,4.74,0,0,1-4.16-5.26l.4-3.46A6.28,6.28,0,0,1,244.53,256Zm19.41,2.79,2.73-23.39a.15.15,0,0,0-.28-.09l-12.5,22.06a.62.62,0,0,0,.47.93l8.88,1A.63.63,0,0,0,263.94,258.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M202.55,223.14c1.23-10.53,7.48-15.91,17.64-14.72s15,7.85,13.78,18.39l-4,34.25c-1.24,10.54-7.49,15.91-17.65,14.73s-15-7.86-13.78-18.4Zm6.27,36.12c-.55,4.71,1.31,6.73,4.61,7.12s5.57-1.16,6.12-5.87L223.7,225c.55-4.71-1.31-6.74-4.61-7.12s-5.57,1.16-6.12,5.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M143.81,173.21a3.5,3.5,0,1,1-3.07-3.87A3.5,3.5,0,0,1,143.81,173.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.55,175.17a3.49,3.49,0,1,1-3.06-3.88A3.49,3.49,0,0,1,160.55,175.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M177.91,177.19a3.49,3.49,0,1,1-3.07-3.87A3.5,3.5,0,0,1,177.91,177.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.75,298.79A90.22,90.22,0,0,0,108.87,319c.34,9.15-.75,69.31-.75,69.31h7.35s10.46-47.11,10.85-50.83S132,296.56,132,296.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.64,296.05s1.69,12.85,4.56,22,17,70.28,17,70.28h7.35s-1.35-47.11-1.86-50.83-4.23-40.93-4.23-40.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.81,388.31v5.13h14a.8.8,0,0,0,.44-1.47c-2-1.36-5.32-3.24-8.37-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.49,388.31v5.13h14a.8.8,0,0,0,.45-1.47c-2.05-1.36-5.33-3.24-8.37-3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M133.73,236.26s4.81-7.31-.71-8c-4.24-.55-6,.71-6,.71s-4.88-.53-7.55,1.78c-1.83,1.59-8.56,13.9,2.31,18.35s8.56-7,8.56-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M133,228.24c-4.24-.55-6,.71-6,.71s-4.88-.53-7.55,1.78c-1.83,1.59-8.56,13.9,2.31,18.35,5.11,2.1,7.31.69,8.2-1.4-10.31,2.91-11.43-9.52-9.73-13.06s5.87-1.93,5.87-1.93c1.63-4.09,6.91-3.64,9.09-3.33A3,3,0,0,0,133,228.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M127,239.82s-1.42-1.43-2.49,0-.36,4.63,1.42,4.81c0,0-.53,4.63-4.1,4.45v3.75h8.38V250s5.17-2.13,5-6.41a23.52,23.52,0,0,0-1.43-7.3A11.67,11.67,0,0,1,127,239.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M128.24,251.17c.83.35.69.87.72,1.66h1.21V250s-2,.65-5-1A13.23,13.23,0,0,0,128.24,251.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M130,233s-4.34-1.73-4.85-.43c-.33.85.51,1.58,1.67,2.32l-1,.16a.27.27,0,0,0-.13.48,5.77,5.77,0,0,0,2.71.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "104.14 280.07 109.95 298.82 109.85 297.87 109.95 298.82 111.92 271.52 104.14 280.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M161,243.87c-8.27-6.13-30.88-11-30.88-11l-1.86,3.4s20.52,8,19.16,9.14c-.79.7-10.82,5.29-14.22,6.84a5.44,5.44,0,0,1-2.33.48l-10.39-.06a16.41,16.41,0,0,0-13.4,5.88c-5.27,6.07-14.23,20.12-14.23,20.12l15.1,22.2,1.67,2.45v.18l1.49.15c4.85.45,20.4,1.68,28.63-.07l.23-.05-.39-36.42a141.22,141.22,0,0,0,21.67-21A1.53,1.53,0,0,0,161,243.87ZM110.3,293.54l-1.48-3.22-4.69-10.25,7.79-8.72-1.4,19.13Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "108.82 290.32 110.3 293.54 109.58 303.25 109.57 303.28 107.9 300.83 108.82 290.32"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M136,265.76c-1.4,1-1,10-1.39,15.65-.58,9.43-1.14,17.59-.73,22.86a40.9,40.9,0,0,0,5.79-.73l.23-.05-.39-36.42a141.22,141.22,0,0,0,21.67-21,1.53,1.53,0,0,0-.25-2.23A185.47,185.47,0,0,1,136,265.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.7,337.49c-.37-2.69-2.41-22.81-3.51-33.81l-5.29.59s7.71,63.33,8.21,84.05h2.45S143.21,341.21,142.7,337.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.84,240.86,107.25,238a10.81,10.81,0,1,0-1.87,2.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.11,232h.42v1.5c0,.46.14.66.46.66s.43-.13.66-.42V232h.42v2.46h-.34l0-.39h0a1,1,0,0,1-.8.45c-.53,0-.76-.34-.76-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M95.82,234.65v.83H95.4V232h.35l0,.28h0a1.23,1.23,0,0,1,.78-.34c.64,0,1,.49,1,1.25s-.5,1.33-1.06,1.33a1.13,1.13,0,0,1-.68-.29Zm.6-.49c.41,0,.7-.37.7-1s-.18-.9-.64-.9a1,1,0,0,0-.66.33v1.29A1,1,0,0,0,96.42,234.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M98.65,233.89a1.11,1.11,0,0,0,.72.29c.33,0,.49-.17.49-.38s-.29-.36-.56-.47-.73-.29-.73-.7.31-.7.84-.7a1.15,1.15,0,0,1,.76.28l-.19.26a.92.92,0,0,0-.56-.22c-.31,0-.45.17-.45.36s.26.31.54.42.75.28.75.74-.32.74-.9.74a1.52,1.52,0,0,1-.92-.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M101.56,233.87a.32.32,0,0,1,0,.64.32.32,0,0,1,0-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M103.32,233.87a.32.32,0,0,1,0,.64.32.32,0,0,1,0-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.5,370.49s-2.26-2.11-.74-10.13,5.37-15.73,3.48-24.44-16.72-30.65-16.77-32.11S48.89,329.34,56.56,340s8.6,14.33,8.26,19.92.07,10.1.92,11.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M66.1,354.36c-.89,3.58-1.43,12.55,0,14.7.14.2.33.09.57-.29-.44-1.48-.72-4.08.1-8.41,1.52-8,5.37-15.73,3.48-24.44s-16.72-30.65-16.77-32.11c0,0,2.23,18.28,9.76,30.87C68.62,343.69,67,350.78,66.1,354.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M70.21,369.94s-4.36-10.88,3-20.3,19.19-21.52,19.43-26.31c0,0,3,22.75-6.58,29.19S69.74,360,71.4,369.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M80.58,348c-10.72,7.8-11.59,16.79-9.93,20.95a1,1,0,0,0,.7.63c-1.44-9.56,5.25-10.65,14.74-17s6.58-29.19,6.58-29.19S91.3,340.14,80.58,348Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M63,370.18a37.89,37.89,0,0,0,.65-12c-.74-6.22-7.24-9.72-13.31-16.29-3.12-3.38-4-21.25-2.11-22.91,0,0-10.72,13-9.06,22.5S58.35,357.19,60,361.78a25.61,25.61,0,0,1,1.49,8.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M44.65,324.11c-3.54,9.59.09,21.21,11.86,28.43,8.66,5.31,5.9,16.36,5.9,16.36l1.42-4.36a35.12,35.12,0,0,0-.14-6.34c-.74-6.22-7.24-9.72-13.31-16.29-3-3.26-4-20-2.3-22.67A58.8,58.8,0,0,0,44.65,324.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M48.08,319.24l.19-.24A1,1,0,0,0,48.08,319.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M72.45,369.46s2.51-9.32,8.73-10.57,13.34-10.44,13.73-12.24C94.91,346.65,93.86,364,72.45,369.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M80.82,362c-3.81,1.9-5.39,4.46-5.95,6.79,19.06-6.13,20-22.11,20-22.11a7,7,0,0,1-1,1.82C92.07,351.75,87.54,358.61,80.82,362Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.89,366H53.4l3.86,24.27A3.79,3.79,0,0,0,61,393.5H78.29A3.8,3.8,0,0,0,82,390.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "85.26 370.05 85.89 366.03 53.4 366.03 54.04 370.05 85.26 370.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M78,366,74.16,390.3a3.79,3.79,0,0,1-3.74,3.2h7.87A3.8,3.8,0,0,0,82,390.3L85.89,366Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 163.16,
    y: 322.75,
    width: 146.86,
    height: 29.86
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 163.16,
    y: 322.75,
    width: 146.86,
    height: 7.25
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "175.93 322.75 189.33 322.75 185.74 330 172.33 330 175.93 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "206.13 322.75 219.53 322.75 215.94 330 202.54 330 206.13 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "236.33 322.75 249.73 322.75 246.14 330 232.74 330 236.33 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "266.53 322.75 279.92 322.75 276.33 330 262.93 330 266.53 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "310.02 322.75 310.02 322.95 306.52 330 293.13 330 296.73 322.75 310.02 322.75"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 181.44,
    y: 352.61,
    width: 10.35,
    height: 40.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 189.44,
    y: 352.61,
    width: 2.35,
    height: 40.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 282.19,
    y: 352.61,
    width: 10.35,
    height: 40.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 289.48,
    y: 352.61,
    width: 3.06,
    height: 40.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 181.44,
    y: 352.58,
    width: 10.35,
    height: 5.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 282.19,
    y: 352.58,
    width: 10.35,
    height: 5.14
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 181.44,
    y: 318.08,
    width: 10.35,
    height: 4.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 189.44,
    y: 318.08,
    width: 2.35,
    height: 4.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 282.19,
    y: 318.08,
    width: 10.35,
    height: 4.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 289.48,
    y: 318.08,
    width: 3.06,
    height: 4.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 181.44,
    y: 322.14,
    width: 10.35,
    height: 0.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 282.19,
    y: 322.14,
    width: 10.35,
    height: 0.58
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "189.33 322.75 174.52 352.61 163.16 352.61 163.16 348.49 175.93 322.75 189.33 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "206.13 322.75 191.32 352.61 204.72 352.61 219.53 322.75 206.13 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "249.73 322.75 234.92 352.61 221.52 352.61 236.33 322.75 249.73 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "279.92 322.75 265.12 352.61 251.72 352.61 266.53 322.75 279.92 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "296.73 322.75 281.92 352.61 295.31 352.61 310.02 322.95 296.73 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "189.33 322.75 185.74 330 172.33 330 175.93 322.75 189.33 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "219.53 322.75 215.94 330 202.54 330 206.13 322.75 219.53 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "249.73 322.75 246.14 330 232.74 330 236.33 322.75 249.73 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "279.92 322.75 276.33 330 262.93 330 266.53 322.75 279.92 322.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "310.02 322.95 306.52 330 293.13 330 296.73 322.75 310.02 322.95"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 167.25,
    y: 335.67,
    width: 140.24,
    height: 14.94
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 186.35,
    cy: 311.6,
    r: 9.23,
    transform: "translate(-47.64 33.98) rotate(-9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.53,311.6a4.19,4.19,0,1,0-4.18,4.19A4.18,4.18,0,0,0,190.53,311.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 287.31,
    cy: 311.6,
    r: 9.23,
    transform: "translate(-46.33 50.2) rotate(-9.24)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M291.49,311.6a4.19,4.19,0,1,0-4.18,4.19A4.18,4.18,0,0,0,291.49,311.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M365.66,390.27H318.89L326,372.93h0l2.88-7,.79-1.91,1.3-3.13.26-.63,2.88-7,.53-1.27,5.1-12.38a2.7,2.7,0,0,1,5,0l5.1,12.38.52,1.27,2.88,7,.27.63,1.29,3.13.79,1.91,2.88,7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "321.96 382.84 318.89 390.27 365.67 390.27 362.6 382.84 321.96 382.84"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 315.15,
    y: 385.83,
    width: 53.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 357.15,
    y: 385.83,
    width: 11.57,
    height: 7.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M363.82,385.83h-6.61l-5.32-12.89h0l-2.88-7-.79-1.92-1.29-3.12-.26-.64-2.88-7-.53-1.27L339,341.56l.81-2a2.7,2.7,0,0,1,5,0l5.1,12.38.52,1.27,2.88,7,.27.64,1.29,3.12.79,1.92,2.88,7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "353.28 360.25 331.27 360.25 334.15 353.25 350.4 353.25 353.28 360.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "358.51 372.92 358.51 372.93 326.04 372.93 326.04 372.92 328.92 365.92 355.63 365.92 358.51 372.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "353.28 360.25 346.67 360.25 343.79 353.25 350.4 353.25 353.28 360.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "358.51 372.92 358.51 372.93 351.89 372.93 351.89 372.92 349.01 365.92 355.63 365.92 358.51 372.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.52,220.21a7,7,0,0,0,7-6,13.28,13.28,0,0,0,.13-1.9,14,14,0,0,0-14-14c-.32,0-.63,0-.94,0a14.83,14.83,0,0,0-29.6,1.26c0,.36,0,.72,0,1.08a14.83,14.83,0,0,0-22,11.87,1.09,1.09,0,0,1,0,.18,7.07,7.07,0,0,0,7.08,7.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M400.65,231.17c11,0,11.65-16.61.62-17.15l-.9,0a18.21,18.21,0,0,0-5.65.89,18.94,18.94,0,0,0-37.46.59,17.57,17.57,0,0,0-11.9-1.15c-9.65,2.48-7.63,16.84,2.34,16.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M268.09,149.32c11,0,11.65-16.6.63-17.14l-.91,0a18.44,18.44,0,0,0-5.64.88,18.93,18.93,0,0,0-37.45.6,17.51,17.51,0,0,0-11.9-1.16c-9.65,2.49-7.62,16.84,2.34,16.84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 92.4,
    cy: 153.56,
    r: 26.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M92.62,127.11a26.46,26.46,0,0,1-14.51,48.58H77.9a26.45,26.45,0,1,0,14.72-48.57Z"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder404);
export default __webpack_public_path__ + "static/media/order-404.27c6a52f5a0da4c4e0b7e4964e5e94df.svg";
export { ForwardRef as ReactComponent };